import port1 from '../img/portImages/maya-1.jpg';
import port3 from '../img/portImages/port2.jpg';
import port4 from '../img/portImages/port3.jpg';
import port6 from '../img/portImages/port5.jpg';

const portfolio = [
    {
        id: 1,
        category: 'Animation',
        link1: 'https://github.com/Porgramming-Hero-web-course/full-stack-client-Nayem1315',
        link2: 'https://super-shop-401d8.web.app/',
        icon1: 'Code',
        icon2: 'Live',
        image: port1,
        title: 'A Super Shop'
    },
    {
        id: 2,
        category: 'Animation',
        link1: 'https://github.com/Porgramming-Hero-web-course/react-router-Nayem1315',
        link2: 'https://gracious-murdock-39cc93.netlify.app/',
        icon1: 'Code',
        icon2: 'Live',
        image: port3,
        title: 'A Football Club'
    },
    {
        id: 3,
        category: 'Javascript',
        link1: 'https://github.com/Porgramming-Hero-web-course/complete-website-client-Nayem1315',
        link2: 'https://assignment-11-aa12d.web.app/',
        icon1: 'Code',
        icon2: 'Live',
        image: port4,
        title: 'A Hair Stylish Salon'
    },
    {
        id: 4,
        category: 'React Js',
        link1: 'https://github.com/Porgramming-Hero-web-course/react-auth-Nayem1315',
        link2: 'https://low-cost-rides.web.app/',
        icon1: 'Code',
        icon2: 'Live',
        image: port6,
        title: 'A Rider map'
    },

]

export default portfolio;